import { PageRenderer, RenderedPage, fetchFile } from './page-renderer';

/** The review page's existing image plate is 470px wide at 100%. */
const IMAGE_BASE_WIDTH_PX: number = 470;

/** An image as a single page. Area pins only — there is no text to select. */
export class ImageRenderer implements PageRenderer {

    readonly paged: boolean = false;
    readonly hasText: boolean = false;

    private page: HTMLElement | null = null;

    async render(src: string, host: HTMLElement): Promise<RenderedPage[]> {
        const el: HTMLDivElement = document.createElement('div');
        el.className = 'pv-page is-image';

        const img: HTMLImageElement = document.createElement('img');
        img.alt = '';
        img.draggable = false;
        await new Promise<void>((resolve, reject) => {
            img.onload = () => resolve();
            img.onerror = () => reject(new Error(`Could not load ${src}.`));
            img.src = src;
        });

        el.appendChild(img);
        host.appendChild(el);
        this.page = el;

        await this.zoom(100);
        return [{ el, label: 'Image' }];
    }

    async zoom(zoom: number): Promise<void> {
        if (this.page) {
            this.page.style.width = `${Math.round(IMAGE_BASE_WIDTH_PX * (zoom / 100))}px`;
        }
    }

    destroy(): void {
        this.page = null;
    }
}

/** A plain `.txt` file as one page of preformatted text. */
export class TextRenderer implements PageRenderer {

    readonly paged: boolean = false;
    readonly hasText: boolean = true;

    private page: HTMLElement | null = null;

    async render(src: string, host: HTMLElement): Promise<RenderedPage[]> {
        const data: ArrayBuffer = await fetchFile(src);

        const el: HTMLDivElement = document.createElement('div');
        el.className = 'pv-page is-text';
        const pre: HTMLPreElement = document.createElement('pre');
        pre.textContent = new TextDecoder().decode(data);
        el.appendChild(pre);
        host.appendChild(el);
        this.page = el;

        return [{ el, label: 'Page 1' }];
    }

    async zoom(zoom: number): Promise<void> {
        this.page?.style.setProperty('zoom', String(zoom / 100));
    }

    destroy(): void {
        this.page = null;
    }
}
